window.aguadecoco = window.aguadecoco || {};

import './helpers/debounce';
import './helpers/storage';
import './helpers/mustache';
import './helpers/events';
import './helpers/validation';
import './helpers/mask';
import './helpers/loader';
import './helpers/format';
import './helpers/additionalProductInfo';
import './helpers/browser-detect';
import './helpers/accordion';
import './helpers/slider';
import './helpers/discountFlag';
import './helpers/vtex-masterdata';
